export enum AccountFeatureFlags {
    LSPD_RSERIES_NUORDER_INTEGRATION = "lspd_rseries_nuorder_integration",
}
